import { Button, TextLink } from '@vds/buttons';
import { Modal, ModalBody, ModalFooter } from '@vds/modals';
import { Body } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { Tilelet } from '@vds/tiles';
import styled from 'styled-components';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { getDestList } from '../../shared/utils/globalUtils';
import { useSelector } from 'react-redux';
import {setModelTagging} from '../utils/tagging';
import { useNavigate } from 'react-router-dom';
import { isNative,  unauth } from '../utils/globalConfig';
import {getDevicesPayload } from '../utils/globalUtils';
import { nativeOpenInWebview } from '../utils/native';
const Space = styled.div`
padding-top: 24px;
`

const PaygoRatesModal = ({ setPaygoRatesModal, setIsPaygoLand, isPaygoLand }) => {

    const navigate = useNavigate();
    const { selectedDestinations, selectedDates,selectedDeviceDetailsUnauth } = useSelector(state => state?.persistantReducer);
   

    const getsDevicesPayloadUnauths = () => {
        let payload = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payload;
    }
    
    const Payload = unauth ? getsDevicesPayloadUnauths() : getDevicesPayload(selectedDates, selectedDestinations);
    const { data } = useGetDevicesAndPlansByNameQuery(Payload)
    
    const [showPaygoRatesObject, setPaygoRatesObject] = useState();
    const [showModal, setShowModal] = useState(true);

    useEffect(() => {
        setPaygoRatesObject(data?.body?.data?.planDetailsLand?.payGoRates);
    }, [data]);

    
    const onOpenedChange = value => {
        setModelTagging('paygoratesModal', 'paygoratesModal', value);
        if (!value) {
             isPaygoLand && setIsPaygoLand(false);
            navigate(-1, { replace: true })
            setPaygoRatesModal(false)
        }
    };

    const onModalClose = () => {
        setShowModal(false);
    }
    const redirectLink = (link) => {
        if (isNative) {
            nativeOpenInWebview(link);
        }else {
            window.open(link);
        }
    }

    return (
        <>
            <Modal
                opened={showModal}
                onOpenedChange={onOpenedChange}
                ariaLabel="PaygoRates Modal"
                id = "paygoratesModal"

            >
                <Tilelet
                    eyebrow={{
                        size: "bodyLarge",
                        children: showPaygoRatesObject?.title
                    }}
                    title={{
                        bold: true,
                        size: 'titleMedium',
                        children: showPaygoRatesObject?.header
                    }}
                    subtitle={{
                        size: 'bodyLarge',
                        children: showPaygoRatesObject?.subText,
                        color: 'primary',
                    }}
                    surface='light'
                    width='100%'
                    height='40%'
                    backgroundColor='black'
                />

                <ModalBody>
                    {showPaygoRatesObject?.countryDetails.map((item, i) => {
                        return (
                            <>
                                <Body size="large" bold>{item?.countryName}</Body>
                                <Body size="large">{item?.data}</Body>
                                <Body size="large">{item?.call}</Body>
                                <Body size="large">{item?.msgSent}</Body>
                                <Body size="large">{item?.msgReceived}</Body>
                                <Space />
                            </>
                        )
                    })}
                    <Space/>
                   { isPaygoLand && <TextLink  onClick={() =>  redirectLink(showPaygoRatesObject?.seePaygoLink)}>{showPaygoRatesObject?.seePaygoLinkText}</TextLink>} 
                </ModalBody>
                <ModalFooter>
                    <Button ariaLabel='PaygoModalCloseButton'data-testid="paygoModalClose" size="large" width="100%" use="secondary" onClick={() => onModalClose()}>{showPaygoRatesObject?.closeButtonText}</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default PaygoRatesModal;